__turbopack_context__.v({
  "className": "josefin_sans_e1c607fb-module__MYRjUW__className",
});
